module.exports = __webpack_public_path__ + "img/8.c3b34a70.png";